// 回合倒计时
export const roundTime = 30;

// 初始化定时器时间
export const defaultSeconds = {
    ready: 10, // 游戏开始倒计时
    change: 10, // 换桌倒计时
    round: roundTime, // 玩家回合倒计时
};

export const msgTag = {
    Fold: 0,
    View: 0,
    CallOnce: 1,
    RaiseVal: 2,
};